import { Injectable } from '@angular/core'
import { HttpClient, HttpParams } from '@angular/common/http'
import { Observable } from 'rxjs'
import { EnvironmentsHelperService } from './environments-helper.service'
import { EnvironmentsConfigsInterface } from '../interfaces/environments-configs.interface'
import { environment } from '../../environment'
import {tap} from "rxjs/operators";

@Injectable({
	providedIn: 'root'
})
export class EnvironmentsService {
	constructor(
		private _http: HttpClient,
		private _environmentsHelperService: EnvironmentsHelperService
	) {}

	public getEnvironmentsConfigs(): Observable<EnvironmentsConfigsInterface> {
		const params: HttpParams = new HttpParams().append('_', Date.now())

		return this._http.get<EnvironmentsConfigsInterface>(environment.environmentsConfigsUrl, { params }).pipe(
			tap((response: EnvironmentsConfigsInterface) => {
				this._environmentsHelperService.environmentsConfigs$.next(response)
			})
		)
	}
}
